
import { functions,auth, } from "@/scripts/firebase"
import {getDocs,getDoc} from "firebase/firestore"
import { NoticeProps } from "@/scripts/datatypes"
import { ValidationObserver } from 'vee-validate'

import { Component,Mixins } from "vue-property-decorator";
import Common from '@/mixins/common';
import { CustomClaims, SchoolPublicProfile, SelectSchoolArg, UserPrivateProfile, UserPublicProfile } from "@/common-datatypes";
import { httpsCallable } from "@firebase/functions";

@Component({
  components: {
    
  }
})

export default class SelectSchool extends Mixins(Common) {
  isLoading = false
  selectSchoolId = ''
  notice: NoticeProps = {}
  schoolsPublicProfile: SchoolPublicProfile[] = []
	schoolOwnersPublicProfile: UserPublicProfile[] = []
	userPrivateProfiles: UserPrivateProfile[] = []

  get name() {
    const lastName = this.$store.state.userPublicProfile.lastName
    const firstName = this.$store.state.userPublicProfile.firstName
    return this.$t('text.name',{lastName: lastName,firstName: firstName}) as string
  }

  get schools(){
    return this.$store.getters.schools as CustomClaims['schools']
  }

  get schoolName() {
    return this.$store.getters.schoolName as string
  }
  
  get observer() {
    return this.$refs.selectSchoolValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  get isDisabled(){
    return this.schoolsPublicProfile.length === 0 || this.selectSchoolId === this.$store.getters.schoolId
  }

  get schoolOwnerName() {
    const school = this.schoolsPublicProfile.find((school) => {
      return school.schoolId === this.selectSchoolId
    })

    if(! school){
      return ''
    }

    const owner = this.schoolOwnersPublicProfile.find((owner) => {
      return owner.userId === school.author
    })

    if(owner){
      return this.$t('text.name',{lastName: owner.lastName,firstName: owner.firstName})
    }

    return ''
  }

  get schoolLastSignInTime() {

    const userPrivateProfile = this.userPrivateProfiles.find((userPrivateProfile) => {
      return userPrivateProfile.schoolId === this.selectSchoolId
    })

    if(userPrivateProfile && userPrivateProfile.lastSignInTime){
      return this.$dateTimeFormat(userPrivateProfile.lastSignInTime)
    }

    return ''
  }

  async created(){
    console.trace('created');
    this.selectSchoolId = this.$store.getters.schoolId

    const schools = await getDocs(this.$getSchoolsPublicProfileQuery())

    this.schoolsPublicProfile = schools.docs.map((doc) => {
      return doc.data() as SchoolPublicProfile
    })

    const owners = await Promise.all(
      this.schoolsPublicProfile.map((school) => {
        return getDoc(this.$getUserPublicProfileDocRef(school.author,school.schoolId))
      })
    )

    this.schoolOwnersPublicProfile = owners.map((doc) => {
      return doc.data() as UserPublicProfile
    })

    const userPrivateProfileDocs = await Promise.all(
      Object.keys(this.schools).map((schoolId) => {
        const userId = this.schools[schoolId].userId
        return getDoc(this.$getUserPrivateProfileDocRef(userId,schoolId))
      })
    )

    this.userPrivateProfiles = userPrivateProfileDocs.map((doc) => {
      return doc.data() as UserPrivateProfile
    })
  }
 
  mounted(){
    console.trace('mounted');
 }

  destroyed() {
    console.trace('destroyed');
  }

  async selectSchool() {
    try{
      this.notice = {
        isShow: false,
      }

      if(! await this.observer.validate()){
        return
      }

      this.$store.commit("setLoading",true);
      this.isLoading = true

      const selectSchool = httpsCallable(functions,'selectSchool')

      await selectSchool({
        schoolId: this.$store.getters.schoolId,
        selectedSchoolId: this.selectSchoolId
      } as SelectSchoolArg)

      this.notice = {
        message: this.$t('selectSchool.selected') as string,
        duration: 2000,
        isShow: true,
        type: {'is-info': true}
      }

      await this.$sleep(2000)

      // eslint-disable-next-line
      const idToken = await auth.currentUser?.getIdTokenResult(true)

      this.observer.reset()
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)
      const errorMessage0 = this.$t('selectSchool.error') as string

      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorField = this.$getErrorField(errorCode)

      if(errorMessage1 && errorField){
        this.observer.setErrors({
         [errorField]: errorMessage1
        })
      }

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }
}

